// Configuração da API
const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://vetim.com.br/api',
  API_URL: process.env.REACT_APP_API_URL || 'https://vetim.com.br/api',
  SOCKET_URL: process.env.REACT_APP_API_URL || 'https://vetim.com.br/api'
};

export default API_CONFIG;